import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import I18n from "i18n-js";

class BookingButtonPresenterInstallation extends React.Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		var self = this;
	}

	render() {
		var tabClasses = clsx({
			'active': this.props.active_tab == 'installation',
			'tab-pane': true,
		})

		return (
			<div className={tabClasses} id="installation">
				<div className="booking-button-installation">
					<div className="panel panel-default">
						<div className="panel-heading"><h3>{I18n.t("how_to_install_booking_button")}</h3></div>
						<div className="panel-body">
							<div className="tabbable tabs-left">
								<ul className="nav nav-tabs">
									<li className="active"><a href="#instructions" data-toggle="tab">{I18n.t("instructions")}</a></li>
									{/* <li><a href="#other" >{I18n.t("other")}</a></li> */}
								</ul>

								<div className="tab-content">
									<div className="tab-pane active" id="instructions">
									<p>{this.htmlEntities(this.props.booking_button_installation_text)}</p>
									<textarea className="form-control" readOnly="readonly" value={this.props.max_reservations_code_link}/>
									</div>
								</div>
							</div>
						</div>
					</div>
				<div className="panel panel-default">
					<div className="panel-heading"><h3>{I18n.t("how_to_open_the_booking_window_from_any_element_on_your_webpage")}</h3></div>
					<div className="panel-body">

						<div className="tabbable tabs-left">
							<ul className="nav nav-tabs">
								<li className="active"><a href="#how_to_open" data-toggle="tab">{I18n.t("instructions")}</a></li>
							</ul>

							<div className="tab-content">
								<div className="tab-pane active" id="how_to_open">
									<p>{I18n.t("booking_button_class_instructions")}</p>
                  <textarea className="form-control" readOnly="readonly" value={'<div className="max-booking" id="max-booking-widget">{I18n.t("make_a_reservation")}</div>\n\nor\n\n<button className="max-booking" id="max-booking-widget">{I18n.t("book_now")}</button>'}/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		)
	}

	htmlEntities(str) {
    return String(str).replace(/&lt;/g, '<').replace(/&gt;/g, '>');
	}
}

export default BookingButtonPresenterInstallation